/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CriteriaTargetGroup } from './CriteriaTargetGroup';
import {
    CriteriaTargetGroupFromJSON,
    CriteriaTargetGroupFromJSONTyped,
    CriteriaTargetGroupToJSON,
    CriteriaTargetGroupToJSONTyped,
} from './CriteriaTargetGroup';

/**
 * 
 * @export
 * @interface CreateCriteriaTargets201Response
 */
export interface CreateCriteriaTargets201Response {
    /**
     * 
     */
    data?: CriteriaTargetGroup;
}

/**
 * Check if a given object implements the CreateCriteriaTargets201Response interface.
 */
export function instanceOfCreateCriteriaTargets201Response(value: object): value is CreateCriteriaTargets201Response {
    return true;
}

export function CreateCriteriaTargets201ResponseFromJSON(json: any): CreateCriteriaTargets201Response {
    return CreateCriteriaTargets201ResponseFromJSONTyped(json, false);
}

export function CreateCriteriaTargets201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCriteriaTargets201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : CriteriaTargetGroupFromJSON(json['data']),
    };
}

export function CreateCriteriaTargets201ResponseToJSON(json: any): CreateCriteriaTargets201Response {
    return CreateCriteriaTargets201ResponseToJSONTyped(json, false);
}

export function CreateCriteriaTargets201ResponseToJSONTyped(value?: CreateCriteriaTargets201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CriteriaTargetGroupToJSON(value['data']),
    };
}

